import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { RecalculateContract } from '../../data-services/recalculate-transactions/recalculate-contracts';
import { RecalculateSetting } from '../../data-services/recalculate-transactions/recalculate-settings/recalculate-settings.model';
import * as fromShared from '../../shared';
import { Process } from '../../shared';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-recalculate-transactions-presenter',
    templateUrl: './recalculate-transactions-presenter.component.html',
    styleUrls: ['./recalculate-transactions-presenter.component.scss'],
    standalone: false
})
export class RecalculateTransactionsPresenterComponent
    implements OnInit, OnDestroy
{
    actionFormGroup: UntypedFormGroup;

    @Input() process: Process;
    @Input() qboEnabled: boolean;
    @Input() hasValidTokens: boolean;
    // @Input()
    // schedules: fromDataServices.RecalculateSchedules.RecalculateSchedule[];
    // public schedules$: Observable<fromDataServices.RecalculateSchedules.RecalculateSchedule[]>;

    private SchedulesSubject = new ReplaySubject<
        Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>
    >(1);
    private _schedules: Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>;
    step2msg: { severity: string; summary: string; detail: string }[];
    @Input() set schedules(
        value: Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>
    ) {
        this._schedules = value;
        this.SchedulesSubject.next(value);
        if (this._schedules && this._schedules.length > 0) {
            //TODO: timer for step 1
            if (this.IsStep1 === true) {
                this.IsStep1BtnDisabled = true;
                this.IsStep2BtnDisabled = true;
                // this.Step1.next(this.processScheduleIDsString);
            }
            if (this.IsStep2 === true) {
                if (this._schedules[0].Timer == true) {
                    this.IsStep2BtnDisabled = true;
                } else {
                    if (this.applyInvoiceChangesBtn) {
                        this.IsDialogVisible$.next(true);
                        this.applyInvoiceChangesBtn = null;
                    } else {
                        // this.Step2.next(this.processScheduleIDsString);
                    }
                }

                this.IsStep2 = false;
            }
            if (this.IsStep3 === true) {
                if (this._schedules[0].Timer == true) {
                    this.IsStatusPending = false;
                } else {
                    this.Step3.next('3');
                }

                this.IsStep3 = false;
            }
        }
    }
    get schedules(): Array<fromDataServices.RecalculateSchedules.RecalculateSchedule> {
        return this._schedules;
    }

    private ContractsSubject = new ReplaySubject<Array<RecalculateContract>>(1);
    private _contracts: Array<RecalculateContract>;
    @Input() set contracts(value: Array<RecalculateContract>) {
        this._contracts = value;
        this.ContractsSubject.next(value);
    }
    get contracts(): Array<RecalculateContract> {
        return this._contracts;
    }

    @Input() initialContracts: RecalculateContract[];

    @Input() settings: RecalculateSetting[];

    @Output() Step1 = new ReplaySubject<{ schedules: string; glOnly: boolean }>(
        1
    );
    @Output() Step2 = new ReplaySubject<any>(1);
    @Output() Step3 = new ReplaySubject<any>(1);

    @Output() GetContracts = new ReplaySubject<{
        PeriodStartDate: Date;
        PeriodEndDate: Date;
    }>(1);

    @Output() GetSchedules = new ReplaySubject<any>(1);

    @Output() GetSettings = new ReplaySubject<any>(1);

    // @Output() GetProcessScheduleIDs = new ReplaySubject<any>(1);

    @Output() ApplyInvoiceChanges = new ReplaySubject<any>(1);

    @Output() UpdateSettings = new ReplaySubject<any>(1);

    @Input() userInfo: IUserInfo;

    @Input() contractsLoading: boolean;

    FYStart: any;
    FYEnd: any;

    processScheduleIDsString: string;

    IsStep1BtnDisabled = true;
    IsStep2BtnDisabled = true;

    public IsDialogVisible$ = new BehaviorSubject(false);

    IsDialogVisible = false;

    applyInvoiceChangesBtn: any;

    public dialogAction$: ReplaySubject<string> = new ReplaySubject<string>(1);

    @Input() clearSelectedSchedules$: Observable<boolean>;

    IsStep1 = false;
    IsStep2 = false;
    IsStep3 = false;

    pageInfo = `Recalcuate period transactions allows reprocessing a period to include eFAACT only changes without requiring import from QuickBooks (step 1). <br>
    All initial processing/QuickBooks changes will require step 1 and can be done from Process Period form in eFAACT Navigator.`;

    step1Tooltip = `
    This step imports QuickBooks transactions for the selected period and is required for initial period processing,
and if changes are made to timecards or QuickBooks DIRECT charges.

If QuickBooks changes impact only INDIRECT costs, use the "Re-Sync Indirect Costs" feature (located bottom right).
    --- QuickBooks administrator access required ---`;

    step2Tooltip = `
    After selecting PERIODS and the CONTRACTS to be invoiced,
this step calculates daily details such as cost, invoice amount, burdens, and fees.
Upon completion, daily and period cost/revenue reports are available for review.

Complete Step 3 for full management reports including invoices and indirect rate schedules.`;

    step3Tooltip = `
    Completes all pending period(s).

This step calculates cumulative summaries, completes INVOICES and calculates experienced INDIRECT RATES.

After completion, all period reporting is available.`;

    active = true;

    accordionTabHeader: string;

    IsStatusPending: boolean;

    constructor(private log: fromShared.Services.Logging.LoggingService) {
        this.actionFormGroup = new UntypedFormGroup({
            STEP1: new UntypedFormControl(),
            STEP2: new UntypedFormControl(),
            STEP3: new UntypedFormControl()
        });
    }

    ngOnInit(): void {
        this.setupObservables();
        this.setupSubscriptions();
        this.step2msg = [
            {
                severity: 'info',
                summary: '',
                detail: this.qboEnabled
                    ? `Step 1 and Step 2 are activated as period(s) are selected. Step 3 completes all 'commit pending' periods.`
                    : `Step 1 and Sync GL require eFAACT Desktop. Step 2 is activated as period(s) are selected. Step 3 completes all "commit pending" periods.`
            }
        ];
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupObservables() {}

    setupSubscriptions() {
        this.FYStart = this.userInfo.FYStartDate;
        this.FYEnd = this.userInfo.FYEndDate;

        this.accordionTabHeader = `Fiscal Year:  ${moment(this.FYStart).format(
            'MM/DD/YYYY'
        )} - ${moment(this.FYEnd).format('MM/DD/YYYY')}`;

        this.IsDialogVisible$.pipe(takeWhile(() => this.active)).subscribe(
            x => {
                this.IsDialogVisible = x;
            }
        );
    }

    step1Clicked(glOnly: boolean) {
        this.IsStep1 = true;
        this.Step1.next({ schedules: this.processScheduleIDsString, glOnly });
        // this.GetSchedules.next({
        //     FyStartDate: null,
        //     FYEndDate: null
        // });
    }
    step2Clicked() {
        this.IsStep2 = true;
        // this.GetSchedules.next({
        //     FyStartDate: null,
        //     FYEndDate: null
        // });
        this.Step2.next(this.processScheduleIDsString);
    }

    step3Clicked() {
        this.IsStep3 = true;
        // this.GetSchedules.next({
        //     FyStartDate: null,
        //     FYEndDate: null
        // });
        this.Step3.next('3');
    }

    onDialogButtonClicked(action) {
        if (action == 'apply') {
            this.dialogAction$.next('apply');
        }
        if (action == 'discard') {
            this.dialogAction$.next('discard');
        }
        this.IsDialogVisible$.next(false);
        this.IsStep2BtnDisabled = true;
    }

    onGetProcessScheduleIDs($event) {
        this.processScheduleIDsString = $event;
    }

    onGetStep2BtnStatus($event) {
        this.log.verbose({
            type: 'RecalculateTransactionsPresenterComponent',
            method: 'onGetStep2BtnStatus',
            data: $event
        });
        this.IsStep2BtnDisabled = $event;
    }

    onGetStep1BtnStatus($event) {
        this.log.verbose({
            type: 'RecalculateTransactionsPresenterComponent',
            method: 'onGetStep1BtnStatus',
            data: $event
        });
        this.IsStep1BtnDisabled = $event;
    }

    onGetContracts($event: { PeriodStartDate: Date; PeriodEndDate: Date }) {
        if (this.applyInvoiceChangesBtn) {
            this.IsDialogVisible$.next(true);
            this.applyInvoiceChangesBtn = null;
        } else {
            this.GetContracts.next($event);
        }
    }

    onGetSchedules($event) {
        this.GetSchedules.next($event);
    }

    onApplyInvoiceChanges($event) {
        this.ApplyInvoiceChanges.next($event);
    }

    onUpdateSettings($event) {
        this.UpdateSettings.next($event);
    }

    onStopAnimation($event) {
        this.applyInvoiceChangesBtn = $event;
    }

    onDisableStep2($event) {
        this.IsStep2BtnDisabled = true;
    }

    onEnableStep2($event) {
        this.IsStep2BtnDisabled = false;
    }

    onDialogAction($event) {}
    onStatusPending($event) {
        this.IsStatusPending = $event;
    }
}
